import React from 'react';
import { IconProps } from '.';

const SvgChecklist = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='m22.555 17.005-5.507 6.057-3.555-3.26 1.014-1.105 2.445 2.241 4.493-4.942 1.11 1.008ZM13 14.75H7v-1.5h6v1.5ZM17 10.75H7v-1.5h10v1.5Z'
        clipRule='evenodd'
      />
      <path
        fill={color}
        fillRule='evenodd'
        d='M17.5 1.5h-11v1.75H2.25v18.5H11v-1.5H3.75V4.75H6.5V6.5h11V4.75h2.75v9.364h1.5V3.25H17.5V1.5ZM16 3H8v2h8V3Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgChecklist;
